import {DceComponent} from "dce-engine";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import Dce from "dce-engine/lib/decorators/Dce";

interface TaskBoardProps {
}

@Dce("TaskBoard")
export default class TaskBoard extends DceComponent<TaskBoardProps> {

    private show: string[] = [];

    constructor(elem: DceHTMLElement, props: TaskBoardProps) {
        super(elem, props);
    }

    public filterPriority(e: Event, elem: HTMLElement){
        let clazz = elem.dataset['class'];

        if(this.show.indexOf(clazz) > -1){
            elem.classList.remove("selected");
            this.show.splice(this.show.indexOf(clazz), 1);
        }else{
            elem.classList.add("selected");
            this.show.push(clazz);
        }

        console.log("CLASSES", this.show);

        this.refresh();
    }

    private refresh(){
        let items = this.elem.getElementsByClassName('board-task')

        for(let i=0; i<items.length; i++){
            let e = items.item(i) as HTMLElement;

            if(this.show.length == 0){
                e.style.display = null;
            }else{
                let visible = false;
                for (const s of this.show) {
                    if(e.classList.contains(s)){
                        visible = true;
                        break;
                    }
                }

                if(visible){
                    e.style.display = null;
                }else{
                    e.style.display = 'none';
                }
            }

        }

    }

}